import { all, call, put, takeEvery } from 'redux-saga/effects'
import OrganizationApiService from './OrganizationApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setIsDropDownsLoading } from 'Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction';
import { GET_COST_CENTER_BY_MARKET } from 'Store/Organization/CostCenterByMarket/CostCenterByMarketType';
import { setCostCenterByMarket } from 'Store/Organization/CostCenterByMarket/CostCenterByMarketAction';

function* getCostCenterByMarketSaga(req: any): any {

    let endpoint = req?.isHierarchy ? `organizations/structure/dropdown/costcenter/${req?.payload?.marketId}` : `organizations/dropdown/costcenter?marketId=${req?.payload?.marketId}`
    yield put(setIsDropDownsLoading(true))
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.Organization,
        endpoint: endpoint,
        payload: req?.payload
    }
    try {
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCostCenterByMarket(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setCostCenterByMarket([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* watchGetAssetTypes() {
    yield takeEvery(GET_COST_CENTER_BY_MARKET, getCostCenterByMarketSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetAssetTypes()
    ])
}
